import React, { useState, useEffect } from 'react';

import { asyncFetch } from '../../helperFunctions';
import { TextField, MenuItem } from '@material-ui/core';

const CloseReasons = props => {
  const { handleCloseReason, ticketId } = props;

  const [firstLevel, setFirstLevel] = useState(null);
  const [secondLevel, setSecondLevel] = useState(null);
  const [reason, setReason] = useState(null);

  const [secondLevelReasons, setSecondLevelReasons] = useState([]);
  const [firstLevelReasons, setFirstLevelReasons] = useState([]);
  const [closeReasons, setCloseReasons] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await asyncFetch(
        `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/second-lvl-reasons`,
        {
          method: 'POST',
          mode: 'cors',
          referrerPolicy: 'strict-origin-when-cross-origin',
          body: JSON.stringify({ ticketIds: ticketId }),
          headers: {
            'Content-Type': 'application/json',
            authorization: `OSS ${localStorage.getItem('OSS_Token')}`,
          },
        },
        undefined,
        undefined,
        undefined
      );

      setSecondLevelReasons(response);
    })();
  }, [ticketId]);

  useEffect(() => {
    if (secondLevel) {
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/first-lvl-reasons`,
          {
            method: 'POST',
            mode: 'cors',
            referrerPolicy: 'strict-origin-when-cross-origin',
            body: JSON.stringify({ ticketIds: ticketId, parentId: secondLevel }),
            headers: {
              'Content-Type': 'application/json',
              authorization: `OSS ${localStorage.getItem('OSS_Token')}`,
            },
          },
          undefined,
          undefined,
          undefined
        );

        setFirstLevelReasons(response);
        setReason(-1);
      })();
    }
  }, [secondLevel, ticketId]);

  useEffect(() => {
    if (firstLevel) {
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/close-reasons`,
          {
            method: 'POST',
            mode: 'cors',
            referrerPolicy: 'strict-origin-when-cross-origin',
            body: JSON.stringify({ ticketIds: ticketId, parentId: firstLevel }),
            headers: {
              'Content-Type': 'application/json',
              authorization: `OSS ${localStorage.getItem('OSS_Token')}`,
            },
          },
          undefined,
          undefined,
          undefined
        );

        setCloseReasons(response);
      })();
    }
  }, [firstLevel, ticketId]);

  let content;

  content = (
    <div>
      <TextField
        label="Главна причина за проблем"
        style={{ margin: '4px' }}
        select
        onChange={x => {
          setSecondLevel(x.target.value);
          setFirstLevel(null);
          handleCloseReason(null);
        }}
        fullWidth
        value={secondLevel}
      >
        {secondLevelReasons.map(x => (
          <MenuItem key={x.id} value={x.id}>
            {x.name}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="Подпричина за проблема"
        style={{ margin: '4px' }}
        select
        disabled={!secondLevel}
        onChange={x => {
          setFirstLevel(x.target.value);
          handleCloseReason(null);
        }}
        fullWidth
        value={firstLevel || -1}
      >
        {secondLevel ? (
          firstLevelReasons.map(x => (
            <MenuItem key={x.id} value={x.id}>
              {x.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem key={-1} value={-1}>
            Моля изберете главна причина
          </MenuItem>
        )}
      </TextField>

      <TextField
        label="Причини за затваряне"
        style={{ margin: '4px' }}
        select
        disabled={!firstLevel}
        onChange={x => {
          setReason(x.target.value);
          handleCloseReason(x.target.value);
        }}
        fullWidth
        value={reason || -1}
      >
        {firstLevel ? (
          closeReasons.map(x => (
            <MenuItem key={x.id} value={x.id}>
              {x.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem key={-1} value={-1}>
            Моля изберете подпричина
          </MenuItem>
        )}
      </TextField>
    </div>
  );

  return content;
};

export default CloseReasons;
